import { useTranslation } from 'react-i18next'

/**
 * The Enamad seal (نماد اعتماد الکترونیکی), Iran's e-commerce registration
 * mark, in the footer of the Persian site — and only there. It certifies
 * parrots.club to Iranian visitors, and an Iranian IP is served the Persian
 * site and nothing else (lib/geoLocale.js), so the seal is on every page
 * such a visitor can reach.
 *
 * The markup is Enamad's own snippet and the parts of it that look
 * redundant are load-bearing: their verifier fetches the site and looks for
 * a real link to trustseal.enamad.ir carrying this id and code, the logo
 * has to stay hot-linked from their server (a copy under public/ fails the
 * check), and `referrerPolicy="origin"` is what tells them which domain is
 * asking — which is why `rel` stops at `noopener` and never reaches
 * `noreferrer`. The one departure from their snippet is the alt text: the
 * link has no other content, so `alt=""` would leave it unannounced.
 *
 * The card is `bg-white` in both themes, not `bg-surface`: the logo is a
 * transparent PNG (125×136, 80% of it see-through) whose "eNAMAD.ir" and
 * «جهت اطمینان کلیک نمایید» lines are dark grey, and on the dark theme's
 * surface (#16202b) they disappear, leaving a blue "e" nobody can read as
 * a seal.
 */
const ENAMAD_ID = '7821001'
const ENAMAD_CODE = 'W4qtltFayeaSFroTI4NABf7OmwbBQDXX'

export default function EnamadSeal() {
  const { t, i18n } = useTranslation('site')
  const language = i18n.resolvedLanguage ?? i18n.language
  if (language !== 'fa') return null

  return (
    <a
      href={`https://trustseal.enamad.ir/?id=${ENAMAD_ID}&Code=${ENAMAD_CODE}`}
      target="_blank"
      rel="noopener"
      referrerPolicy="origin"
      title={t('footer.enamadAlt')}
      className="block w-[104px] self-start rounded-2xl border-2 border-line bg-white p-1.5 transition hover:-translate-y-0.5"
    >
      <img
        src={`https://trustseal.enamad.ir/logo.aspx?id=${ENAMAD_ID}&Code=${ENAMAD_CODE}`}
        alt={t('footer.enamadAlt')}
        code={ENAMAD_CODE}
        referrerPolicy="origin"
        width="125"
        height="136"
        className="h-auto w-full"
      />
    </a>
  )
}
